(function () {
  if (window.__bfx) return; window.__bfx = 1;
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-bf-copy]"); if (!b) return;
    e.preventDefault();
    var code = b.getAttribute("data-bf-copy"), lab = b.querySelector("span");
    function done() {
      b.classList.add("ok"); var old = lab ? lab.textContent : null; if (lab) lab.textContent = "Copied";
      clearTimeout(b._t); b._t = setTimeout(function () { b.classList.remove("ok"); if (lab && old !== null) lab.textContent = old; }, 1600);
    }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(done, fallback); }
      else fallback();
    } catch (x) { fallback(); }
    function fallback() {
      var t = document.createElement("textarea"); t.value = code; t.setAttribute("readonly", ""); t.style.position = "fixed"; t.style.opacity = "0";
      document.body.appendChild(t); t.select(); try { document.execCommand("copy"); } catch (y) {} t.remove(); done();
    }
  });

  function initPx() {
    var j = document.querySelector("[data-bfx-px]"); if (!j) return;
    var map; try { map = JSON.parse(j.textContent); } catch (x) { return; }
    var last = null;
    function sync() {
      var inp = document.querySelector("[data-pd-vid]"); if (!inp) return;
      var cents = map.v[inp.value]; if (cents == null || cents === last) return; last = cents;
      var p = map.p[cents]; if (!p) return;
      document.querySelectorAll("[data-bfx-p]").forEach(function (el) { var k = +el.getAttribute("data-bfx-p"); if (p[k]) el.textContent = p[k]; });
    }
    var pr = document.querySelectorAll("[data-pd-price],[data-pd-add-p]");
    if (window.MutationObserver) pr.forEach(function (el) { new MutationObserver(sync).observe(el, { childList: true, subtree: true, characterData: true }); });
    document.addEventListener("change", function () { setTimeout(sync, 0); });
    sync();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initPx); else initPx();
})();
